import React from 'react'
import { IoCloseOutline } from "react-icons/io5";

function Modal({open, onClose, children}) {
  return (
    <div onClick={onClose} className={`
       fixed inset-0 flex justify-center items-center transition-colors
       ${open ? 'visible bg-black/50' : 'invisible'}
    `}>

        <div 
        onClick={(e) => e.stopPropagation()}
        className={`
            bg-white rounded-lg shadow p-3 transition-all w-1/2 h-3/4 flex-col flex
            ${open ? 'opacity-100' : ' opacity-0'}
        `}>
            <button onClick={onClose} className='self-end p-1 text-gray-400 hover-bg-gray-50 hover:text-gray-600'>
                <IoCloseOutline className='text-2xl' />
            </button>

            {children}

        </div>
    </div>
  )
}

export default Modal